/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type ContactDealerInlineForm_viewer$ref = any;
type PdpSharedDealerDetailsStats_viewer$ref = any;
type PdpSharedSellerTabsVariant_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespDealerDetails_viewer$ref: FragmentReference;
export type PdpRespDealerDetails_viewer = {|
  +isMessageCenterEnabled: ?boolean,
  +isReviewsEnabled: ?boolean,
  +isEmbeddedMakeOfferTestDisabled: ?boolean,
  +$fragmentRefs: PdpSharedDealerDetailsStats_viewer$ref & ContactDealerInlineForm_viewer$ref & PdpSharedSellerTabsVariant_viewer$ref,
  +$refType: PdpRespDealerDetails_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespDealerDetails_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isMessageCenterEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "MESSAGE_CENTER",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"MESSAGE_CENTER\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isReviewsEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "ORDER_FEEDBACK",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"ORDER_FEEDBACK\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isEmbeddedMakeOfferTestDisabled",
      "name": "isEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "disablePdpEmbeddedMakeOfferTest",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabled(key:\"disablePdpEmbeddedMakeOfferTest\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsStats_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ContactDealerInlineForm_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerTabsVariant_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '4ad8cfca48562c65f474bd3ffb104f49';
module.exports = node;
